import { render, staticRenderFns } from "./DiscoveryDetail.vue?vue&type=template&id=5184defd"
import script from "./DiscoveryDetail.vue?vue&type=script&lang=js"
export * from "./DiscoveryDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {MoleculeButtonBreadcrumbBack: require('/home/userapp/components/Molecule/Button/ButtonBreadcrumbBack.vue').default,MoleculeButtonMobileLyre: require('/home/userapp/components/Molecule/Button/ButtonMobileLyre.vue').default,AtomIconX: require('/home/userapp/components/Atom/Icon/IconX.vue').default,MoleculeMaskVisual: require('/home/userapp/components/Molecule/MaskVisual.vue').default,AtomIconPlay: require('/home/userapp/components/Atom/Icon/IconPlay.vue').default,AtomHeadingDetailPageMain: require('/home/userapp/components/Atom/Heading/HeadingDetailPageMain.vue').default,MoleculeButtonShort: require('/home/userapp/components/Molecule/Button/ButtonShort.vue').default,MoleculeDiscoveryShort: require('/home/userapp/components/Molecule/DiscoveryShort.vue').default,OrganismLoaderFromUri: require('/home/userapp/components/Organism/Loader/LoaderFromUri.vue').default,MoleculeButton: require('/home/userapp/components/Molecule/Button/Button.vue').default,OrganismPageSectionContent: require('/home/userapp/components/Organism/PageSectionContent.vue').default,MoleculeMatrix: require('/home/userapp/components/Molecule/Matrix/Matrix.vue').default,MoleculeCardOverview: require('/home/userapp/components/Molecule/Card/CardOverview.vue').default,TemplateBase: require('/home/userapp/components/Template/Base.vue').default})
